
const mostrarMensagemSucesso = (mensagemToast,mensagem) => {
    mensagemToast.current.show({
        severity: 'success',
        summary: 'Sucesso',
        detail: mensagem,
        life: 4000,
        closable: false
    });
};

const mostrarMensagemErro = (mensagemToast,mensagem) => {
    mensagemToast.current.show({
        severity: 'error',
        summary: 'Erro',
        detail: mensagem,
        life: 4000,
        closable: false
    });
};

export { mostrarMensagemSucesso, mostrarMensagemErro

};